var EmailFormPhoneNumberInputView, EmailFormTextInputView, GrouponValidate,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

EmailFormTextInputView = require('./text_input_view');

GrouponValidate = require('../../../../../groupon/frontend/validate');

EmailFormPhoneNumberInputView = (function(superClass) {
  extend(EmailFormPhoneNumberInputView, superClass);

  function EmailFormPhoneNumberInputView() {
    return EmailFormPhoneNumberInputView.__super__.constructor.apply(this, arguments);
  }

  EmailFormPhoneNumberInputView.prototype.tagName = 'li';

  EmailFormPhoneNumberInputView.prototype.events = {
    'keyup .phone_number_input': 'checkPhoneNumber'
  };

  EmailFormPhoneNumberInputView.prototype.initialize = function() {
    EmailFormTextInputView.prototype.initialize.apply(this, arguments);
    this.elementID = ".phone_number_input";
    this.errorElementID = '.validatePhoneNumberInput';
    return this.template = {
      phone_input_template: true
    };
  };

  EmailFormPhoneNumberInputView.prototype.isInputValid = function(hideErrorMsg) {
    var isValidPhoneNumber, phoneNumber;
    phoneNumber = this.getInputHtmlElement().val();
    isValidPhoneNumber = true;
    this.hideErrorElements();
    if (phoneNumber !== "") {
      isValidPhoneNumber = window.isUS() ? GrouponValidate.phone(phoneNumber) : GrouponValidate.phoneInternational(phoneNumber);
      $('.phone-number-input').find('.icon-circle-alert').remove();
      $('.phone-number-input').removeClass('error');
      if (isValidPhoneNumber) {
        this.$el.find(this.errorElementID).css('display', 'none');
        $('.call-back-phone-number-input').removeClass('call-back-inputs-error-border');
      } else if (!hideErrorMsg) {
        this.$el.find(this.errorElementID).css('display', 'block');
        $('.phone-number-input').append('<span class="icon icon-circle-alert"></span>');
        $('.phone-number-input').addClass('error');
      }
    }
    return isValidPhoneNumber;
  };

  EmailFormPhoneNumberInputView.prototype.hideErrorElements = function() {
    $('.phone-number-input').find('.icon-circle-alert').remove();
    $('.phone-number-input').removeClass('error');
    this.$el.find(this.errorElementID).css('display', 'none');
    return $('.call-back-phone-number-input').removeClass('call-back-inputs-error-border');
  };

  EmailFormPhoneNumberInputView.prototype.checkPhoneNumber = function() {
    this.isInputValid(true);
    return this.validateEmailForm();
  };

  EmailFormPhoneNumberInputView.prototype.populateInput = function(data) {
    if (this.isInputGiven()) {
      data.user_given_phone = this.readInput();
      return EmailFormTextInputView.prototype.populateInput.apply(this, arguments);
    }
  };

  return EmailFormPhoneNumberInputView;

})(EmailFormTextInputView);

module.exports = EmailFormPhoneNumberInputView;

//# sourceMappingURL=data:application/json;base64,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
